var EmailFormPhoneNumberInputView, EmailFormTextInputView, GrouponValidate,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

EmailFormTextInputView = require('./text_input_view');

GrouponValidate = require('../../../../../groupon/frontend/validate');

EmailFormPhoneNumberInputView = (function(superClass) {
  extend(EmailFormPhoneNumberInputView, superClass);

  function EmailFormPhoneNumberInputView() {
    return EmailFormPhoneNumberInputView.__super__.constructor.apply(this, arguments);
  }

  EmailFormPhoneNumberInputView.prototype.tagName = 'li';

  EmailFormPhoneNumberInputView.prototype.events = {
    'keyup .phone_number_input': 'checkPhoneNumber'
  };

  EmailFormPhoneNumberInputView.prototype.initialize = function() {
    EmailFormTextInputView.prototype.initialize.apply(this, arguments);
    this.elementID = ".phone_number_input";
    this.errorElementID = '.validatePhoneNumberInput';
    return this.template = {
      phone_input_template: true
    };
  };

  EmailFormPhoneNumberInputView.prototype.isInputValid = function(hideErrorMsg) {
    var isValidPhoneNumber, phoneNumber;
    phoneNumber = this.getInputHtmlElement().val();
    isValidPhoneNumber = true;
    this.hideErrorElements();
    if (phoneNumber !== "") {
      isValidPhoneNumber = window.isUS() ? GrouponValidate.phone(phoneNumber) : GrouponValidate.phoneInternational(phoneNumber);
      $('.phone-number-input').find('.icon-circle-alert').remove();
      $('.phone-number-input').removeClass('error');
      if (isValidPhoneNumber) {
        this.$el.find(this.errorElementID).css('display', 'none');
        $('.call-back-phone-number-input').removeClass('call-back-inputs-error-border');
      } else if (!hideErrorMsg) {
        this.$el.find(this.errorElementID).css('display', 'block');
        $('.phone-number-input').append('<span class="icon icon-circle-alert"></span>');
        $('.phone-number-input').addClass('error');
      }
    }
    return isValidPhoneNumber;
  };

  EmailFormPhoneNumberInputView.prototype.hideErrorElements = function() {
    $('.phone-number-input').find('.icon-circle-alert').remove();
    $('.phone-number-input').removeClass('error');
    this.$el.find(this.errorElementID).css('display', 'none');
    return $('.call-back-phone-number-input').removeClass('call-back-inputs-error-border');
  };

  EmailFormPhoneNumberInputView.prototype.checkPhoneNumber = function() {
    this.isInputValid(true);
    return this.validateEmailForm();
  };

  EmailFormPhoneNumberInputView.prototype.populateInput = function(data) {
    if (this.isInputGiven()) {
      data.user_given_phone = this.readInput();
      return EmailFormTextInputView.prototype.populateInput.apply(this, arguments);
    }
  };

  return EmailFormPhoneNumberInputView;

})(EmailFormTextInputView);

module.exports = EmailFormPhoneNumberInputView;

//# sourceMappingURL=data:application/json;base64,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
